import { useTranslation } from "react-i18next";
import { mapEdgesToNodes } from "../../../base/utils";
import { Note } from "../../../helbest";
import { usePageTypesQuery, usePagesQuery } from "../../../saleor/api";
import { PageContentsTransformer } from "../../../services/objectTransformer/home";
import { useSelector } from "react-redux";
import { useMemo } from "react";                                  
import { useSearchParams } from "react-router-dom";               
import useCategory from "../../components/Home/CategoryBar/useCategory"; 

const useHome = () => {
  const { i18n } = useTranslation();
  const { channel } = useSelector((state) => state.Login);

  const [searchParams] = useSearchParams();
  const { categories } = useCategory();
  const catId = searchParams.get("cat")?.split(",")[0];
  const categorySlug = useMemo(
    () => categories.find((c) => c.id === catId)?.slug ?? null,
    [categories, catId]
  );

  const { data: pageTypesData } = usePageTypesQuery({
    variables: {
      first: 50,
    },
    onError: (err) => {
      Note.error(err.message);
    },
  });

  const homePageBannerId =
    pageTypesData &&
    mapEdgesToNodes(pageTypesData.pageTypes.edges)
      .filter(
        (node) => node.slug === "home-page-banner" || node.slug === "header"
      )
      .map((node) => node.id);

  const { data } = usePagesQuery({
    variables: {
      first: 20,
      filter: {
        pageTypes: pageTypesData && homePageBannerId,
        metadata: [{ key: "lang", value: i18n.language.toUpperCase() }],
      },
      lng: i18n.language.toUpperCase(),
    },
    skip: !pageTypesData,
    onError: (error) => {
      Note.error(error.message);
    },
  });

  return { contents: PageContentsTransformer(data, channel,categorySlug) };
};

export default useHome;
